import { Link } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '@/hooks/useAuth';

export default function VerifyPasswordBanner() {
  const { user } = useAuth();
  if (!user || user.is_verified !== false) return null;

  return (
    <div className="border-b border-warning-200 bg-warning-50 px-4 py-2 text-sm text-warning-900">
      <div className="mx-auto flex max-w-7xl items-center gap-3">
        <ExclamationTriangleIcon className="h-5 w-5 shrink-0 text-warning-600" aria-hidden="true" />
        <span className="flex-1">
          You're using a temporary password.{' '}
          <Link to="/forgot-password" className="font-semibold underline hover:text-warning-700">
            Set a permanent password
          </Link>{' '}
          to secure your account.
        </span>
      </div>
    </div>
  );
}
